<template>
  <div class="hello-home">
    <!-- <span @click="login">宁波海员服务平台</span> -->
    <div class="liner-color">
      <div class="home-search" :class="{ modified: modifyStyle }">
        <el-select
          :class="isSelect == true ? 'my-el-select' : 'other-select'"
          v-model="value"
          placeholder="请选择"
          style="width: 110px; height: 45px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          class="my-input-home"
          v-model="crewValue"
          placeholder="请输入你想要搜索的职位"
        ></el-input>
        <el-button type="primary" class="my-button-home" @click="homeSearch"
          >搜索</el-button
        >
      </div>
      <p class="search-p" :class="{ 'search-white': modifyStyle }"></p>
      <div class="home-nav">
        <div class="home-button">
          <div class="love-mess">
            <img src="../../assets/love-icon.png" alt="" />
            <span>船员服务</span>
          </div>
          <div class="icons-list">
            <div class="icons-mess" style="cursor: pointer" @click="moreJob">
              <img src="../../assets/crew-icon.png" alt="" />
              船员求职
            </div>
            <div class="icons-mess" @click="moreTrain" style="cursor: pointer">
              <img src="../../assets/people-icon.png" alt="" />
              船员培训
            </div>
            <div
              class="icons-mess"
              style="text-align: center; cursor: pointer"
              @click="noData"
            >
              <img src="../../assets/mess-icon.png" alt="" />
              证书办理
            </div>
            <div class="icons-mess" style="cursor: pointer" @click="noData">
              <img src="../../assets/health-icon.png" alt="" />
              船员体检
            </div>
            <div class="icons-mess" style="cursor: pointer" @click="noData">
              <img src="../../assets/credit-icon.png" alt="" />
              小证更新
            </div>
            <div
              class="icons-mess"
              @click="twoCode"
              style="text-align: center; cursor: pointer"
            >
              <img src="../../assets/more-icon.png" alt="" />
              更多...
            </div>
          </div>
        </div>

        <el-carousel height="280px" class="home-carousel" :autoplay="false">
          <el-carousel-item>
            <!-- <h3 class="small">{{ item }}</h3> -->
            <div class="car-blue">
              <!-- <div class="car-img">
                <img src="../../assets/largeScreen1.png" alt="" />
              </div> -->
              <!-- <div class="car-title">
                <div class="car-font1">服务船员 服务航企为核心</div>
                <div class="car-font1">百万船员的安心管家</div>
                <div class="car-font2" style="margin-top: 20px">
                  院校信息透明、成本节约
                </div>
                <div class="car-font2">降低企业成本、提升使用效率</div>
                <div class="car-font2">简单易用、效果出众</div>
              </div> -->
            </div>
            <!-- <img src="../../assets/shouye-nav.png" alt="" /> -->
          </el-carousel-item>
          <el-carousel-item>
            <div class="home-video">
              <video
                controls="controls"
                :src="lanVideo"
                controlslist="nodownload"
                poster="https://info.lanshuimu.com/intro.png"
              ></video>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="message">
          <div class="message-title">
            <div class="title-icon"></div>
            航运资讯
          </div>
          <div class="didver"></div>
          <div
            class="title-message"
            v-for="(item, index) in newsList"
            :key="item.id"
          >
            <div class="title-font" @click="gotoNews(item)">
              {{ item.title }}
            </div>
            <div class="title-icon">
              <div>{{ item.createTime }}发布</div>
              <div><i class="el-icon-view"></i>{{ item.readNum }}浏览</div>
            </div>
            <div class="didver2" v-if="index != 2"></div>
          </div>
          <div class="more-news" @click="moreNews"><div>查看更多</div></div>
        </div>
      </div>
      <div class="country">
        <div class="country-city">
          <div class="country-img"></div>
          <div class="country-font">
            <div class="font-city">覆盖全国港口城市</div>
            <countTo
              class="font-count"
              :startVal="startVal"
              :endVal="endVal1"
              :duration="3000"
            ></countTo>
          </div>
        </div>
        <div class="country-city">
          <div class="country-img2"></div>
          <div class="country-font">
            <div class="font-city">全国航运企业合作</div>
            <countTo
              class="font-count"
              :startVal="startVal"
              :endVal="endVal2"
              :duration="3000"
            ></countTo>
            <!-- <div class="font-count">652</div> -->
          </div>
        </div>
        <div class="country-city">
          <div class="country-img3"></div>
          <div class="country-font">
            <div class="font-city">打造高品质培训院校</div>
            <countTo
              class="font-count"
              :startVal="startVal"
              :endVal="endVal3"
              :duration="3000"
            ></countTo>
            <!-- <div class="font-count">35</div> -->
          </div>
        </div>
        <div class="country-city">
          <div class="country-img4"></div>
          <div class="country-font">
            <div class="font-city">数万船员的信赖之选</div>
            <countTo
              class="font-count"
              :startVal="startVal"
              :endVal="endVal4"
            ></countTo>
            <!-- <div class="font-count">57042</div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="member">船员一站式服务，百万船员的安心管家</div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      class="member-tabs"
      stretch
    >
      <el-tab-pane label="船员求职" name="first">
        <div class="member-job">
          <div
            v-for="(item, index) in jobList"
            :key="index"
            @click="gotoJob(item)"
            class="member-index"
            :style="{
              marginTop:
                index != '0' && index != '1' && index != '2' ? '1.5rem' : '0',
            }"
          >
            <div class="member-flex">
              <div class="member-font">
                {{ item.positionName }}
                <div class="member-new">
                  <img src="../../assets/new-fire.png" alt="" />
                </div>
              </div>

              <div class="member-prize" v-if="!item.mianyi">
                {{ item.salaryBegin }}-{{ item.salaryEnd }}万元
              </div>
              <div class="member-prize" v-if="item.mianyi">
                {{ item.mianyi }}
              </div>
            </div>
            <div class="member-yaoqiu">
              <span>{{ item.shipTypeName }}</span
              ><span>{{ item.recuritShipTon }}吨</span
              ><span
                >{{ item.workingYearBegin }}-{{
                  item.workingYearEnd
                }}航海经验</span
              ><span
                >{{ item.locationProvinceName }}-{{
                  item.locationPortName
                }}</span
              >
            </div>
            <div class="member-biaoqian">
              <p v-if="item.welfareTag.length == 0"></p>
              <div v-for="val in item.welfareTag" :key="val">{{ val }}</div>
            </div>
            <div class="member-didver"></div>
            <div class="member-univser">
              <div class="univser">{{ item.companyName }}</div>
              <div class="univser-time">{{ item.refreshTime }}</div>
            </div>
          </div>
          <div class="member-more"><div @click="moreJob">更多职位</div></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="船员培训" name="second">
        <div class="member-pane">
          <div
            v-for="(item, index) in trainList"
            :key="index"
            class="member-index"
            @click="gotoTrain(item)"
            :style="{
              marginTop:
                index != '0' && index != '1' && index != '2' ? '1.5rem' : '0',
            }"
          >
            <div class="member-font">{{ item.trainTitle }}</div>
            <div class="member-biaoqian">
              <div>热门培训</div>
              <div>名额有限</div>
            </div>
            <div class="member-prize">
              <div class="member-prize">{{ item.trainPrice }}元</div>
              <div class="member-last">
                剩<span
                  :style="{ color: item.planNum <= 5 ? '#ef5151' : '#2aba48' }"
                  >{{ item.planNum }}</span
                >个名额
              </div>
            </div>
            <div class="member-didver"></div>
            <div class="member-univser">
              <div class="univser">{{ item.companyName }}</div>
              <div class="univser-time">{{ item.publishTime }}开课</div>
            </div>
          </div>
          <div class="member-more"><div @click="moreTrain">更多培训</div></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="船员体检" name="third">
        <div class="health-img">
          <img
            style="height: 22.4286rem"
            src="../../assets/noShipCrew.png"
            alt=""
          />
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="crew">
      <div class="crew-blue">
        <div class="blue-title">应用场景介绍</div>
        <div class="blue-title2">
          以技术为驱动，为用户、行业和社会创造更大的价值
        </div>
      </div>
      <div class="crew-list">
        <div class="crew-img">
          <div class="work-img work-img1"></div>
          <div class="work-font">企业直聘</div>
          <div class="work-mess">找船员就上"浙船员"</div>
        </div>
        <div class="crew-img">
          <div class="work-img work-img2"></div>
          <div class="work-font">校企合作</div>
          <div class="work-mess">人才储备就上"浙船员"</div>
        </div>
        <div class="crew-img">
          <div class="work-img work-img4"></div>
          <div class="work-font">健康体检</div>
          <div class="work-mess">高效体检就上"浙船员"</div>
        </div>
        <div class="crew-img">
          <div class="work-img work-img6"></div>
          <div class="work-font">航运百科</div>
          <div class="work-mess">航运信息查询就上"浙船员"</div>
        </div>
        <div class="crew-img" style="margin-top: 23px">
          <div class="work-img work-img3"></div>
          <div class="work-font">船员培训</div>
          <div class="work-mess">院校信息公开、资费透明</div>
        </div>

        <div class="crew-img" style="margin-top: 23px">
          <div class="work-img work-img5"></div>
          <div class="work-font">法律咨询</div>
          <div class="work-mess">全面的法律咨询服务</div>
        </div>

        <div class="crew-img" style="margin-top: 23px">
          <div class="work-img work-img7"></div>
          <div class="work-font">技术咨询</div>
          <div class="work-mess">
            线上提出问题,由专业人员进行解答 效率高,服务好
          </div>
        </div>
        <div class="crew-img" style="margin-top: 23px">
          <div class="work-img work-img8"></div>
          <div class="work-font">海事工作室</div>
          <div class="work-mess">专业的海事工作室服务</div>
        </div>
      </div>
    </div>
    <div class="information">
      <div class="information-font">
        <div class="blue-title">围绕船员业务场景，为船员提供专业化服务</div>
        <!-- <div class="blue-title2">
          依托蓝水母在航运互联网领域的积累，使数据贯穿航运互联网的各个
        </div> -->
      </div>
      <div class="information-list">
        <!-- <div class="list-one">船员是基石</div> -->
        <!-- <div class="list-two"> -->
        <!-- 围绕船员业务场景，为船员提供一站式专家服务数据是基础
          
          数据是企业数字化转型的基础，数据贯穿工业互联网的各个环节，<br />工业数据的获取与应用是工业互联网落地的基础。 -->
        <!-- </div> -->
        <div class="list-three">
          依托蓝水母在航运互联网领域的积累，使数据贯穿航运互联网的各个<br />
          环节，吸纳优质的企业、律师事务所、培训机构、体检机构、保险等入驻,<br />解决船员就业难、培训难、维权难等问题。
          <!-- 依托蓝水母在航运互联网领域的积累，使数据贯穿航运互联网的各个<br />环节，为航运互联网落地提供基础支撑，帮助企业解决痛点问题。 -->
        </div>
        <div class="list-four"><span>√</span>解决终端数据采集问题</div>
        <div class="list-four">
          <span>√</span>解决数据与数据间的交互、数据分析应用问题
        </div>
        <div class="list-four"><span>√</span>为船员应用提供信息支撑</div>
        <div class="list-four"><span>√</span>保障船员合法权益</div>
        <div class="cicle-list"></div>
      </div>
    </div>
    <div class="member-hexin">平台核心优势</div>
    <div class="icon-list">
      <div class="icon-one">
        <div class="one-img one1"></div>
        <div class="one-font">专业</div>
        <div class="two-font">
          1V1专业咨询服务<br />为用户提供场景化解决方案
        </div>
      </div>
      <div class="icon-one">
        <div class="one-img one2"></div>
        <div class="one-font">合规</div>
        <div class="two-font">合规闭环服务<br />让您的体验更加顺畅</div>
      </div>
      <div class="icon-one">
        <div class="one-img one3"></div>
        <div class="one-font">便捷</div>
        <div class="two-font">自主研发系统<br />全程在线操作,便捷高效</div>
      </div>
      <div class="icon-one">
        <div class="one-img one4"></div>
        <div class="one-font">安全</div>
        <div class="two-font">系统全程监管<br />确保用户资料安全</div>
      </div>
    </div>
    <div class="member-fengxian">水母云中台，为各方保驾护航</div>
    <div class="manage">
      <div class="manage-img">
        <div class="wenzi wenzi1">银行合作<br />保障资金安全性</div>
        <div class="wenzi wenzi2">实名认证,保障信息合法性</div>
        <div class="wenzi wenzi3">数据异地存储<br />确保数据安全性</div>
        <div class="wenzi wenzi4">敏感数据加密处理<br />确保用户隐私不泄漏</div>
        <div class="wenzi wenzi5">分级分类存储<br />避免垃圾数据冗余</div>
      </div>
    </div>
    <div class="member-hexin">合作伙伴</div>
    <div class="company-icon">
      <ul>
        <li @click="lookCompany('http://www.nbosco.com/')" class="yuanyangLi">
          <img
            class="yuanyang"
            src="../../assets/company-six.png"
            alt=""
          />宁波远洋运输股份有限公司
        </li>
        <li @click="lookCompany('http://www.zh-gs.com/')" class="yuanyangLi">
          <img
            class="gaosu"
            src="../../assets/company-eight.png"
            alt=""
          />珠海高速客轮有限公司
        </li>
        <li>
          <img
            class="gaosu"
            src="../../assets/company-two.png"
            alt=""
          />上海锦江航运有限公司
        </li>
        <li
          @click="lookCompany('http://www.zhonggu56.com/index.jsp')"
          class="yuanyangLi"
        >
          <img
            class="zhonggu"
            src="../../assets/company-seven.png"
            alt=""
          />中谷物流
        </li>
        <li>
          <img
            class="gaosu"
            src="../../assets/company-five.png"
            alt=""
          />宁波北仑船务有限公司
        </li>
        <li>
          <img
            class="hengxing"
            src="../../assets/company-four.png"
            alt=""
          />宁波恒兴船务有限公司
        </li>
        <li>
          <img
            class="gaosu"
            src="../../assets/company-three.png"
            alt=""
          />宁波宇凡海运有限公司
        </li>
        <li @click="lookCompany('http://www.jslyzh.com/')" class="yuanyangLi">
          <img
            class="longyuan"
            src="../../assets/company-one.png"
            alt=""
          />江苏龙源振华海洋工程有限公司
        </li>
      </ul>
    </div>
    <el-dialog :visible.sync="codeVisible" width="37.8571rem" class="code-two">
      <div class="two-img">
        <img src="../../assets/twoCode-title.png" alt="" />
      </div>
      <div class="two-content">
        <div class="two-font" style="margin-top: 2.0714rem">
          使用船员服务小程序，体验更多优质服务
        </div>
        <div class="two-font" style="margin-top: 1.2857rem">
          扫码即用，无需等待
        </div>
        <div class="two-ma">
          <img src="../../assets/lan-code.jpg" alt="" />
          <img src="../../assets/ma-code.jpg" alt="" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  login,
  querySeafarerNewsList,
  queryJobsList,
  selectAlITrainplanNotePublishList,
} from "@/apis/index";
import { apiUrl } from "@/config";
import countTo from "vue-count-to";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {
    countTo,
  },
  data() {
    return {
      test: "",
      codeVisible: false,
      crewValue: "",
      activeName: "first",
      newsList: [],
      jobList: [],
      trainList: [],
      options: [
        {
          value: "1",
          label: "船员招聘",
        },
        {
          value: "2",
          label: "船员培训",
        },
      ],
      value: "1",
      startVal: 0,
      endVal1: 39,
      endVal2: 652,
      endVal3: 35,
      endVal4: 57042,
      scrollTop: 0,
      modifyStyle: false,
      isSelect: true,
      lanVideo: "https://info.lanshuimu.com/intro.mp4",
      lanVideo2: "",
    };
  },
  mounted() {
    this.querySeafarerNews();
    this.queryJobs();
    this.selectAlITrainplanNotePublish();
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    this.test = process.env.NODE_ENV;
    this.url = process.env.VUE_APP_BASE_URL;
  },
  computed: {
    // modifyStyle() {
    //   return this.scrollTop > 100; // 根据需要修改的距离来设置条件
    // }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async login() {
      await login({
        loginName: "jstzmsa",
        plainPassword: "1F02F43B7E431F941262EB09268F53BA",
      });
    },
    //滑动更改样式
    handleScroll() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
      // console.log(this.scrollTop);
      if (this.scrollTop >= 150) {
        this.modifyStyle = true;
      } else {
        this.modifyStyle = false;
      }
    },
    lookCompany(src) {
      window.open(src);
    },
    //航运资讯
    async querySeafarerNews() {
      let res = await querySeafarerNewsList({
        pageSize: 3,
        pageNo: 1,
      });
      //       const timestamp = 1686713742000;
      // const date = new Date(timestamp);
      // const formattedDate = date.toISOString().slice(0, 10);
      res.resultList.forEach((item) => {
        let date = new Date(item.createTime);
        item.createTime = date.toISOString().slice(0, 10);
      });
      this.newsList = res.resultList;
    },
    async gotoNews(item) {
      // const res = await querySeafarerNewsById({ id: item.id });
      this.$router.push({ name: "crewNewsDetail", params: { id: item.id } });
      // console.log(res);
    },
    //职位
    async queryJobs() {
      const res = await queryJobsList({ pageSize: 6, pageNo: 1 });
      // console.log(res);
      res.data.resultList.forEach((item) => {
        item.welfareTag = JSON.parse(item.welfareTag);
        item.welfareTag = item.welfareTag.slice(0, 3);
        item.refreshTime = item.refreshTime.split(" ")[0];
        item.salaryBegin = (item.salaryBegin / 10000).toFixed(2);
        item.salaryEnd = (item.salaryEnd / 10000).toFixed(2);
        if (item.salaryBegin == 0 && item.salaryEnd == 0) {
          item.mianyi = "面议";
        }
      });
      this.jobList = res.data.resultList;
    },
    //培训
    async selectAlITrainplanNotePublish() {
      const res = await selectAlITrainplanNotePublishList({
        pageSize: 6,
        pageNo: 1,
      });
      res.data.resultList.forEach((item) => {
        // item.welfareTag = JSON.parse(item.welfareTag);
        item.publishTime = item.publishTime.split(" ")[0];
      });
      this.trainList = res.data.resultList;
      // console.log(res);
    },
    //更多新闻
    moreNews() {
      this.$router.push("/crewNewsMore");
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    navigateTo(url) {
      // 创建 XMLHttpRequest 对象
      var xhr = new XMLHttpRequest();

      // 监听请求状态变化
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            // 请求成功，执行页面跳转
            window.location.href = url;
          } else {
            // 请求失败，执行错误处理逻辑
            console.error("请求失败");
          }
        }
      };

      // 发送 GET 请求
      xhr.open("GET", url, true);
      xhr.send();
    },
    //更改箭头方向
    changeSelect() {
      this.isSelect = !this.isSelect;
      console.log(this.isSelect);
    },
    //招聘
    gotoJob(item) {
      // console.log(item);
      if (
        sessionStorage.getItem("tolog") &&
        (sessionStorage.getItem("userType") == 0 ||
          sessionStorage.getItem("userType") == 5 ||
          sessionStorage.getItem("userType") == 4 ||
          sessionStorage.getItem("userType") == 9)
      ) {
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/postDetail/${
          item.jobId
        }/?tolog=${sessionStorage.getItem("tolog")}`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/postDetail/${item.jobId}/?homeTitle=true`;
      }
    },
    //培训
    gotoTrain(item) {
      // console.log(item);
      if (
        (sessionStorage.getItem("tolog") &&
          sessionStorage.getItem("userType") == 0) ||
        sessionStorage.getItem("userType") == 4 ||
        (sessionStorage.getItem("userType") == 1 &&
          sessionStorage.getItem("isLand") == 0)
      ) {
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${
          item.id
        }/0?tolog=${sessionStorage.getItem("tolog")}`;
        // window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${item.id}/0?homeTitle=true`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${item.id}/0?homeTitle=true`;
      }
    },
    //更多职位
    moreJob() {
      let menuType = sessionStorage.getItem("menuType") || "";
      if (menuType == 1) {
        if (
          sessionStorage.getItem("tolog") &&
          (sessionStorage.getItem("userType") == 0 ||
            sessionStorage.getItem("userType") == 5 ||
            sessionStorage.getItem("userType") == 4)
        ) {
          window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/companyHome?tolog=${sessionStorage.getItem(
            "tolog"
          )}&companyId=${sessionStorage.getItem("companyId")}`;
        } else {
          sessionStorage.clear();
          window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/crewHome?homeTitle=true`;
        }
      } else {
        if (
          sessionStorage.getItem("tolog") &&
          (sessionStorage.getItem("userType") == 0 ||
            sessionStorage.getItem("userType") == 5 ||
            sessionStorage.getItem("userType") == 4)
        ) {
          window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/crewHome?tolog=${sessionStorage.getItem(
            "tolog"
          )}`;
        } else {
          sessionStorage.clear();
          window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/crewHome?homeTitle=true`;
        }
      }
    },
    //更多培训
    moreTrain() {
      if (
        (sessionStorage.getItem("tolog") &&
          sessionStorage.getItem("userType") == 0) ||
        sessionStorage.getItem("userType") == 4 ||
        (sessionStorage.getItem("userType") == 1 &&
          sessionStorage.getItem("isLand") == 0)
      ) {
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/home?tolog=${sessionStorage.getItem(
          "tolog"
        )}`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/home?homeTitle=true`;
      }
    },
    noData() {
      this.$router.push({
        name: "noData",
      });
    },
    //更多...
    twoCode() {
      this.codeVisible = true;
    },
    //搜索框
    homeSearch() {
      if (this.value == "1") {
        if (this.crewValue != "") {
          this.$router.push({
            name: "jobDetail",
            params: { positionOrCompany: this.crewValue },
          });
        } else {
          this.$router.push({
            name: "jobDetail",
            params: { positionOrCompany: "all" },
          });
        }
      } else if (this.value == "2") {
        if (this.crewValue != "") {
          this.$router.push({
            name: "trainDetail",
            params: { trainTitle: this.crewValue },
          });
        } else {
          this.$router.push({
            name: "trainDetail",
            params: { trainTitle: "all" },
          });
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// h3 {
//   margin: 40px 0 0;
// }
// ul {
//   list-style-type: none;
//   padding: 0;
// }
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
// a {
//   color: #42b983;
// }
</style>
